/**
 * @requires jquery drilldown plugin by Cinamonas
 * https://github.com/Cinamonas/jquery-drilldown/
 */
(function() {

    var is_drilldown = false;

    var drilldown = '.js-drilldown';
    var $drilldown = $(drilldown);

    var drilldownWrapper = '.js-drilldown-wrapper';
    var $drilldownWrapper = $(drilldownWrapper);

    var drilldownTrigger = '.js-drilldown-trigger';
    var $drilldownTrigger = $(drilldownTrigger);

    var drilldownLink = '.js-drilldown__link';
    var $drilldownLink = $(drilldownLink);

    var shopIndexUrl = '.js-drilldown__link--reset';
    var $shopIndexUrl = $(shopIndexUrl).eq(0);

    var drilldownItem = '.js-drilldown__item';
    var $drilldownItem = $(drilldownItem);

    var drilldownSubMenu = '.js-drilldown__sub-menu';
    var $drilldownSubMenu = $(drilldownSubMenu);

    var products = '#js-products';
    var $products = $(products);

    var pagination = '#js-pagination';
    var $pagination = $(pagination);

    var brandSelect = '.js-brand-select';
    var $brandSelect = $(brandSelect);

    var ajaxRequest = null;

    var params = {
        drilldownClasses: {
            container: 'js-drilldown__container',
            root: 'js-drilldown__root',
            sub: 'js-drilldown__sub-menu',
            back: 'js-drilldown__back'
        },
        drilldown_max_width: _breakpoints.s,
        triggeredClass: 'is-triggered',
        currentClass: 'is-current',
        openClass: 'is-open',
        parentLinkClass: 'js-drilldown__link--has-children',
        loadingDOMClass: 'is-loading',
        changingDOMClass: 'is-changing',
        filters: [
            $brandSelect
        ],
        changingTransitionDuration: 200,
        slideToggleDuration: 166,
    };

    //	======================================================================  //
    //	Functions
    //	======================================================================  //

    /**
     * @function `toggleDrilldownMenu`
     *
     * Show/hide the drilldown menu.
     */
    function toggleDrilldownMenu() {
        $drilldownWrapper.slideToggle(params.slideToggleDuration);
        $drilldownTrigger.toggleClass(params.triggeredClass);
    }

    /**
     * @function `forceCloseDrilldownMenu`
     *
     * Closes the drilldown menu without any animation.
     */
    function forceCloseDrilldownMenu() {
        $drilldownWrapper.hide();
        $drilldownTrigger.removeClass(params.triggeredClass);
    }

    /**
     * @function `autoDrill`
     *
     * Programmatically drills to the deepest pane of the drilldown by clicking
     * on each parent link, one at a time.
     */
    function autoDrill() {
        var $level = $drilldown.find(drilldownSubMenu+'.'+params.openClass);
        var $levelLink = $level.siblings(drilldownLink);
        for(var i = 0, count = $levelLink.length; i < count; i++) {
            $levelLink[i].click();
        }
    }

    /**
     * @function `init`
     *
     * Transforms the default navigation pattern into a drilldown menu.
     *
     * 1. Alternative to non-existing `afterInit` event handler.
     */
    function init() {
        $drilldown.drilldown({
            cssClass: {
                container: params.drilldownClasses.container,
                root: params.drilldownClasses.root,
                sub: params.drilldownClasses.sub,
                back: params.drilldownClasses.back
            }
        });
        setTimeout(function() { /* [1] */
            is_drilldown = true;
            autoDrill();
        }, 1000);
    }

    /**
     * @function `kill`
     *
     * Cancels the transformation of the default navigation pattern into a
     * drilldown menu.
     */
    function kill() {
        $drilldown.drilldown('destroy');
        forceCloseDrilldownMenu();
        is_drilldown = false;
    }

    /**
     * @function `initOrKill`
     *
     * Initializes or kills transformation into a dropdown.
     */
    function initOrKill() {
        if( _window_width >= params.drilldown_max_width ) {
            if( is_drilldown ) {
                kill();
            }
            else {
                return;
            }
        }
        else {
            if( is_drilldown ) {
                return;
            }
            else {
                init();
            }
        }
    }

    /**
     * @function `updateTriggerLabel`
     *
     * Updates the trigger label using the one of the clicked product category.
     *
     * @param $link (node) - the clicked product category link
     */
    function updateTriggerLabel( $link ) {
        var shortLabel = $link.attr('data-short-label');
        var newTriggerlabel = shortLabel ? shortLabel : $link.text();
        $drilldownTrigger.text(newTriggerlabel);
    }

    /**
     * @function `updateCurrentCategoryInDrilldown`
     *
     * Removes the "current" class on all links to product categories in the
     * drilldown and applies it on the clicked link.
     *
     * 1. If link resets the filters, then add the "current" class to the
     *    original reset links (those in the navigation).
     * 1.1. When clicking the "all products" button at the end of the list of
     *      new products.
     *
     * @param $link (node) - the clicked link
     */
    function updateCurrentCategoryInDrilldown( $link ) {
        $drilldownLink.removeClass(params.currentClass);
        if ($link.hasClass(shopIndexUrl.slice(1, shopIndexUrl.length))) { /* [1] */
            $shopIndexUrl = $(shopIndexUrl);
            if ($shopIndexUrl.length > 2) { /* [1.1] */
                $shopIndexUrl.eq(0).addClass(params.currentClass);
                $shopIndexUrl.eq(1).addClass(params.currentClass);
            } else {
                $shopIndexUrl.addClass(params.currentClass);
            }
        } else {
            $link.addClass(params.currentClass);
        }
    }

    /**
     * @function `loadingFeedback`
     *
     * Show feedback when loading.
     */
    function loadingFeedback() {
        _$html.addClass(params.loadingDOMClass);
    }

    /**
     * @function `replaceContent`
     *
     * Empty the original content node and fill it with the new content.
     *
     * @param `data` - the AJAX response
     * @param `target` (str) - the target element in the response (class, id, ...)
     * @param `$container` (node) - the containing element for the new content
     * @param `transitionDuration` (int) - same as the transition duration in CSS.
     *
     * 1. Same as the transition duration in CSS.
     */
    function replaceContent( data, target, $container, transitionDuration ) {
        var $data = $(data);
        var $dataTarget = $data.find(target);
        _$html.addClass(params.changingDOMClass);
        setTimeout(function() {
            $container.empty().append($dataTarget.html());
        }, transitionDuration); /* [1] */
    }

    /**
     * @function `returnCurrentBaseUrl`
     *
     * Returns the base url matching the currently displayed products: no
     * parameters, just the url with the current product category (if any).
     *
     * @return str
     */
    function returnCurrentBaseUrl() {
        var $currentCategoryLink = $(drilldownLink +
            '.' + params.currentClass);
        var baseUrl = '';
        if( !$currentCategoryLink.length ) {
            baseUrl = $shopIndexUrl.attr('href');
        }
        baseUrl = $currentCategoryLink.eq(0).attr('href');
        return baseUrl;
    }

    /**
     * @function `returnUrlWithParams`
     *
     * Returns a built url with GET parameters if any.
     *
     * @param basicUrl (str) - the URL without any parameters
     * @param $params (arr) - an array of form controls as
     * jQuery nodes (selectors)
     *
     * @return str
     *
     * 1. If value is defined
     */
    function returnUrlWithParams( basicUrl, $params ) {
        var params = '';
        var paramsCount = $params.length;
        if( !paramsCount ) {
            return basicUrl;
        }
        for( var i = 0; i < paramsCount; i++ ) {
            var paramName = $($params[i]).attr('name');
            var paramValue = $($params[i]).val();
            if( paramValue.length && paramValue !== 0 ) { /* [1] */
                params += ( i === 0 ) ? '?' : '&';
                params += paramName + '=' + paramValue;
            }
        }
        return basicUrl + params;
    }

    /**
     * @function `getProducts`
     *
     * Get the products for the selected product category.
     *
     * @param url (str) - the base URL without any parameters
     *
     * 1. Abort any pending (ongoing) ajax request. Bear in mind aborting will
     *    trigger the `complete` function.
     */
    function getProducts( url ) {
        var urlWithParams = returnUrlWithParams(url, params.filters);
        // console.log('New request:', urlWithParams);
        ajaxRequest = $.ajax({
            url: urlWithParams,
            type: 'GET',
            headers: {
                'accept': 'application/json',
            },
            beforeSend: function() {
                if( ajaxRequest !== null ) {
                    ajaxRequest.abort(); /* [1] */
                }
                loadingFeedback();
            },
            success: function(data) {
                replaceContent(data, products, $products,
                    params.changingTransitionDuration);
                replaceContent(data, pagination, $pagination,
                    params.changingTransitionDuration);
                window.history.pushState(null, null, urlWithParams);
            },
            error: function() {
                return;
            },
            complete: function(jqXHR, textStatus) {
                if( textStatus !== 'abort' ) {
                    setTimeout(function() {
                        _$html.removeClass(params.loadingDOMClass + ' ' +
                            params.changingDOMClass);
                    }, params.changingTransitionDuration * 2);
                }
            }
        });
    }

    /**
     * @function `expandCollapse`
     *
     * Expands or collapses relevant sub menus in the architecture, depending on
     * the clicked product category.
     *
     * @param $link (node) - the clicked product category link
     *
     * 1. Quick escape if product category does not have sub entries and is not
     *    the "reset" category (all products).
     * 2. If clicking the "reset" category (which does not have any sub entries),
     *    close all sub menus.
     * 3. The direct sub menu for this product category.
     * 4. The sub menus that are not the direct sub menu for the clicked link.
     *    We'll need to close them if clicking up the tree of opened menus.
     * 5. Vital parent menus that have been previously expanded. If we close them,
     *    we won't see the link we just clicked on as it is part of that tree.
     * 6. We can confidently close sub menus that are not directly related to the
     *    link we just clicked on.
     * 7. Close all the sub menus that are not vital (up the tree of the clicked
     *    link and directly related to the clicked link).
     * 8. Expand the sub menu that is directly related to the clicked link.
     * 9. Remove the "current" class on any link appearing in the drilldown but
     *    the one we clicked.
     */
    function expandCollapse( $link ) {
        if( !$link.hasClass(params.parentLinkClass) ) {
            if( !$link.is(shopIndexUrl) ) { /* [1] */
                return;
            }
            else { /* [2] */
                $drilldownSubMenu.slideUp(params.slideToggleDuration);
            }
        }

        var $directSubMenu = $link.siblings(drilldownSubMenu); /* [3] */
        var $deeperSubMenus = $link.closest(drilldownItem)
            .find(drilldownSubMenu).not($directSubMenu); /* [4] */
        var $parentMenus = $link.parents(drilldownSubMenu); /* [5] */

        $deeperSubMenus.slideUp(params.slideToggleDuration); /* [6] */
        $drilldownSubMenu.not($parentMenus).not($directSubMenu)
            .slideUp(params.slideToggleDuration); /* [7] */
        $directSubMenu.slideDown(params.slideToggleDuration); /* [8] */
    }

    /**
     * @function `selection`
     *
     * Selects the clicked product category.
     *
     * @param $link (node) - the clicked product category link
     *
     * 1. Quick escape if clicking the already selected product category and
     *    products are not filtered by brand.
     * 2. Quick escape if nav is a drilldown and the link has sub entries.
     * 3. If link resets the filter, make sure to update the trigger label with
     *    its original label (useful when clicking another "reset" button that
     *    might have a different label, e.g. at the end of the "New"
     *    products listing).
     */
    function selection( $link ) {
        if( $link.hasClass(params.currentClass) && !$brandSelect.val().length ) { /* [1] */
            return;
        }
        $brandSelect.prop('selectedIndex', 0);
        if( $brandSelect.closest('.selectric-wrapper').length ) {
            $brandSelect.selectric('refresh');
        }
        if( !is_drilldown ) {
            expandCollapse( $link );
        } else {
            if( $link.hasClass(params.parentLinkClass) ) { /* [2] */
                return;
            }
        }
        if ($link.hasClass(shopIndexUrl.slice(1, shopIndexUrl.length))) { /* [3] */
            updateTriggerLabel( $shopIndexUrl.eq(0) );
        } else {
            updateTriggerLabel( $link );
        }
        updateCurrentCategoryInDrilldown( $link );
        if( is_drilldown && $drilldownTrigger.hasClass(params.triggeredClass)) {
            toggleDrilldownMenu();
        }
        getProducts( $link.attr('href') );
    }

    //	======================================================================  //
    //	On ready
    //	======================================================================  //

    onReady.callbacks.initDrilldown = function() {
        initOrKill();
    };

    //	======================================================================  //
    //	On resize
    //	======================================================================  //

    onResize.callbacks.drilldownOrNot = function() {
        initOrKill();
    };

    //	======================================================================  //
    //	On click
    //	======================================================================  //

    _$document.on('click', drilldownTrigger, function(e) {
        e.preventDefault();
        toggleDrilldownMenu();
    });

    //	======================================================================  //
    //	On selection
    //	======================================================================  //

    /**
     * 1. If not on the product index page or on a product category page
     *    (e.g. on a single product page), just go to the target page.
     */
    _$document.on('click', drilldownLink, function(e) {
        if( !$products.length ) { /* [1] */
            return;
        }
        e.preventDefault();
        var $link = $(this);
        selection( $link );
    });

    //	======================================================================  //
    //	On brand change
    //	======================================================================  //

    _$document.on('change', brandSelect, function(e) {
        var baseUrl = returnCurrentBaseUrl();
        getProducts( baseUrl );
    });

})();
